import { makeStyles } from '@material-ui/core/styles';
import { SizeType } from 'src/common/enumerations/cashier-preference-level';
import { themeColor } from 'src/mui-theme';

interface NumberPadStyleProps {
  doubleWidth?: boolean;
  nonNumerical?: boolean;
  buttonSize: SizeType;
}

export const styles = makeStyles(() => ({
  wrapper: ({ doubleWidth, buttonSize }: NumberPadStyleProps) => {
    const paddingAdjustment = buttonSize > 0 ? '90%' : '100%';
    return {
      width: '100%',
      padding: 0,
      paddingTop: doubleWidth ? 0 : paddingAdjustment,
      height: doubleWidth ? '100%' : 0,
      position: 'relative',
    };
  },
  buttonContainer: {
    height: '100%',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    '&&': {
      width: '100%',
    },
    '&.disabled': {
      opacity: 0.5,
      pointerEvents: 'none',
    },
    '& > button': {
      border: `1px solid ${themeColor.secondaryLight}`,
      borderRadius: '2px',
      boxShadow: `0px 1px 2px ${themeColor.lightBackground}`,
      boxSizing: 'border-box',
      padding: 4,
      color: themeColor.subheaderLight,
      height: '100%',
      width: '100%',
      background: ({ nonNumerical }: NumberPadStyleProps) =>
        nonNumerical ? themeColor.lightBackground : 'none',
    },
  },
}));
